import { createContext, use, type ReactNode } from "react";

export interface SelectedInputFieldRenderContextValue {
  data?: string;
}

const SelectedInputFieldRenderContext =
  createContext<SelectedInputFieldRenderContextValue | null>(null);

export const useSelectedInputFieldRenderOverride =
  (): SelectedInputFieldRenderContextValue | null => {
    return use(SelectedInputFieldRenderContext);
  };

export interface SelectedInputFieldRenderProviderProps {
  data?: string;
  children: ReactNode;
}

export const SelectedInputFieldRenderProvider = ({
  data,
  children,
}: SelectedInputFieldRenderProviderProps) => {
  return (
    <SelectedInputFieldRenderContext value={{ data }}>
      {children}
    </SelectedInputFieldRenderContext>
  );
};
